import React, { useEffect, useState } from "react";
import { TextField, Button, Box, FormControl, InputLabel, Select, MenuItem, Divider, Typography } from "@mui/material";
import customHttp from "../../services/customHTTP";
import Swal from "sweetalert2";

const DefaultValues = () => {
	const [formData, setFormData] = useState({
		currency: "USD",
		minOrderAmount: 0,
		creditCardFee: 2.5,
		taxRate: 5,
		shippingCost: 10,
		leadTime: 3,
		mfaDays: 15,
		mfaEnabled: true,
	});

	useEffect(() => {
		const fetchOptions = async () => {
			try {
				const response = await customHttp.get("options");
				const responseData = response.data.data;
				const updatedFormData = responseData.reduce((acc, item) => {
					return {
						...acc,
						[item.option_key]: isNaN(item.option_value) ? item.option_value : Number(item.option_value),
					};
				}, {});

				setFormData(updatedFormData);
			} catch (error) {
				console.log(error);
			}
		};
		fetchOptions();
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		console.log("Form submitted with values:", formData);
		const req_body = Object.entries(formData).map(([key, value]) => ({
			option_key: key,
			option_value: value,
		}));

		console.log(req_body);
		try {
			const resp = await customHttp.post("options/insert", { options: req_body });
			if (resp.data.status) {
				Swal.fire({
					icon: "success",
					title: "Success",
					text: resp.data.message,
					confirmButtonText: "Okay",
				});
			}
		} catch (error) {
			console.log(error);
		}
		// Handle the submission (e.g., API call)
	};

	return (
		<Box
			sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", width: "80%", marginTop: 2 }}>
			<form onSubmit={handleSubmit} style={{ width: "60%" }}>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<Typography variant="body1" fontWeight={"bold"}>
						Order Settings
					</Typography>
					<Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
						<FormControl fullWidth size="small">
							<InputLabel>Default Currency</InputLabel>
							<Select
								name="currency"
								value={formData.currency}
								onChange={handleChange}
								label="Default Currency"
								size="small">
								<MenuItem value="USD">USD</MenuItem>
								<MenuItem value="EUR">EUR</MenuItem>
								<MenuItem value="GBP">GBP</MenuItem>
								<MenuItem value="INR">INR</MenuItem>
							</Select>
						</FormControl>
					</Box>{" "}
					<Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
						<TextField
							label="Minimum Order Amount"
							variant="outlined"
							name="minOrderAmount"
							type="number"
							value={formData.minOrderAmount}
							onChange={handleChange}
							size="small"
							fullWidth
						/>
					</Box>
					<Divider />
					{/* <Typography variant="body1" fontWeight={"bold"}>
						Payment Modes
					</Typography>
					<Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
						<FormControl fullWidth size="small">
							<InputLabel>Credit Card Payments</InputLabel>
							<Select
								name="ccPayment"
								value={formData.ccPayment}
								onChange={handleChange}
								label="Credit Card Payments"
								size="small">
								<MenuItem value="Enabled">Enabled</MenuItem>
								<MenuItem value="Disabled">Disabled</MenuItem>
							</Select>
						</FormControl>
						<TextField
							label="Credit Card Fee (%)"
							variant="outlined"
							name="creditCardFee"
							type="number"
							value={formData.creditCardFee}
							onChange={handleChange}
							size="small"
							fullWidth
						/>
					</Box>
					<Divider />
					<Typography variant="body1" fontWeight={"bold"}>
						Shipping & Taxes
					</Typography>
					<Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
						
						<TextField
							label="Lead Time (Days)"
							variant="outlined"
							name="leadTime"
							type="number"
							value={formData.leadTime}
							onChange={handleChange}
							size="small"
							fullWidth
						/>
						<TextField
							label="Tax Rate (%)"
							variant="outlined"
							name="taxRate"
							type="number"
							value={formData.taxRate}
							onChange={handleChange}
							size="small"
							fullWidth
						/>
					</Box>
					<Divider />
					<Typography variant="body1" fontWeight={"bold"}>
						Inventory
					</Typography>
					<Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
						<FormControl fullWidth size="small">
							<InputLabel>Track Invetory</InputLabel>
							<Select
								name="trackInventory"
								value={formData.trackInventory}
								onChange={handleChange}
								label="Track Invetory"
								size="small">
								<MenuItem value="Enabled">Enabled</MenuItem>
								<MenuItem value="Disabled">Disabled</MenuItem>
							</Select>
						</FormControl>
						<FormControl fullWidth size="small">
							<InputLabel>BackOrders</InputLabel>
							<Select
								name="backOrders"
								value={formData.backOrders}
								onChange={handleChange}
								label="BackOrders"
								size="small">
								<MenuItem value="Enabled">Enabled</MenuItem>
								<MenuItem value="Disabled">Disabled</MenuItem>
							</Select>
						</FormControl>
					</Box>
					<Divider /> */}
					<Typography variant="body1" fontWeight={"bold"}>
						Multi Factor Authentication (MFA)
					</Typography>
					<Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
						<FormControl fullWidth size="small">
							<InputLabel>MFA Status</InputLabel>
							<Select
								name="mfaEnabled"
								value={formData.mfaEnabled}
								onChange={handleChange}
								label="MFA Enabled"
								size="small">
								<MenuItem value="Enabled">Enabled</MenuItem>
								<MenuItem value="Disabled">Disabled</MenuItem>
							</Select>
						</FormControl>
						<TextField
							label="MFA Frequency (Days)"
							variant="outlined"
							name="mfaDays"
							type="number"
							value={formData.mfaDays}
							onChange={handleChange}
							size="small"
							fullWidth
						/>
					</Box>
				</Box>
				<Box sx={{ display: "flex", justifyContent: "flex-start", marginTop: 2 }}>
					<Button type="submit" variant="contained" color="primary">
						Submit
					</Button>
				</Box>
			</form>
		</Box>
	);
};

export default DefaultValues;
